// being used
import jsPDF from "jspdf";
import "jspdf-autotable";

export const exportPDF = (
  ppeRecords,
  complianceData,
  formatCreatedAtDate,
  strict
) => {
  const doc = new jsPDF({
    orientation: "landscape",
  });

  // Prepare static headers
  const staticHeaders = [
    "Observer",
    "Facility",
    "Unit",
    "Collection Date",
    "Precautions",
    "HCW Type",
    "Compliance",
    "Audit Strict Compliance",
  ];

  // Add dynamic headers based on the form questions
  const dynamicHeaders =
    ppeRecords.length > 0
      ? ppeRecords[0].formQuestions.flatMap((section, sectionIndex) =>
          section.questions.map(
            (_, questionIndex) => `OP${sectionIndex + 1}-${questionIndex + 1}`
          )
        )
      : [];

  const headers = [...staticHeaders, ...dynamicHeaders];

  // Prepare table data
  const data = ppeRecords.map((record, recordIndex) => {
    const staticData = [
      record.nurse,
      record.facility,
      record.unit,
      formatCreatedAtDate(record.createdAt),
      record.precautions,
      record.healthCareWorker,
      `${complianceData[recordIndex].numericValue}%`,
      record.auditStrictCompliance.toString(),
    ];

    const dynamicData = record.formQuestions.flatMap((section) =>
      section.questions.map((q) => q.response.value)
    );

    return [...staticData, ...dynamicData];
  });

  // Add table to document
  doc.autoTable({
    head: [headers],
    body: data,
    theme: "striped",
    styles: {
      fontSize: 8,
      cellPadding: 1,
      lineColor: [0, 0, 0], // Color of the lines
      lineWidth: 0.5, // Width of the lines
    },
    tableWidth: "auto",
  });

  // Save the PDF
  doc.save(`PPE_Records_${new Date().toISOString()}.pdf`);
};
